export const NOTIFICATION_TYPE_SUCCESS = 'success'

export const NOTIFICATION_TYPE_ERROR = 'error'
